/* eslint-disable no-unused-vars */
/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */

import React, { useEffect } from "react";
import Footer from "../../Layout/Footer";
// import Header from "../Home/Header";
import Header from "../../Layout/Header";
import ScrollTopOnMount from "../../Layout/ScrollTopOnMount";
import { Col, Container, Row } from "react-bootstrap";
import { useParams } from "react-router-dom";
import { connect } from "react-redux";
import { getPageBySlug } from "../../../actions/auth";
import { Interweave } from "interweave";
import { CommonPageData } from '../../../styles/common.style';

const Page = ({ getPageBySlug, page }) => {
  let { slug } = useParams()
  useEffect(() => {
    getPageBySlug(slug)
  }, [slug])
  return (
    <>
      <ScrollTopOnMount />
      <Header />
      <div className={'clearfix'}></div>
      <CommonPageData>
        {/* <section className={'recomended-products'}> */}
        <div className='common-banner-block'>
          <div className='main-banner'>
            <img src='../images/banner-common-block.png' alt='img' />
          </div>
          <div className='container'>
            <div className='common-banner-block-inner'>
              <h1>{page ? page.name : ''}</h1>
            </div>
          </div>
        </div>
        {page?.template == 'bodytype_assesment' ? (
          <>
            <div className='assesment-info'>
              <p>This is more than just a quiz-it's a hands-on, 30-45-minute guided process.</p>
              <div className='container'>
                <div className='assesment-info-block'>
                  <div className='assesment-info-block-left'>
                    <h3>What to Expect<br></br>
                      From the Assessment:</h3>
                    <ol>
                      <li>
                        <h4>Create Your Account</h4>
                        <p>Secure your progress and receive your results privately.</p>
                      </li>
                      <li>
                        <h4>Fill Out a Quick Intake Form</h4>
                        <p>Tell us about your current of past injuries, goals, and areas of concern.
                        </p>
                      </li>
                      <li>
                        <h4>Watch a Step-By-Step Instruction Video</h4>
                        <p>We'll show you exactly how to set up your phone and perform each movement test.
                        </p>
                      </li>
                      <li>
                        <h4>Record & Upload Your Movement Images or Videos</h4>
                        <p>You'll film short clips of yourself performing guided movements using just your phone.</p>
                      </li>
                      <li>
                        <h4>Get Your Results</h4>
                        <p>Our Al will analyze your movements and assign your personalized corrective program- all within minutes.
                        </p>
                      </li>
                    </ol>
                  </div>
                  <div className='assesment-info-block-right'>
                    <div className='assesment-info-block-right-inner'>
                      <h3>Get Ready to Discover<br></br> Your <span>BODY TYPE!</span></h3>
                      <div className='assesment-info-box'>
                        <h4>What you will Need:</h4>
                        <ul>
                          <li>30-45 minutes of quiet time</li>
                          <li>Form-fitting clothes (explained in the video)</li>
                          <li>A phone & tripod (or someone to take your pictures)</li>
                          <li>Enough space to move safely</li>
                        </ul>
                      </div>
                      <div className='btn-block-assesment'>
                        <button className='theme-common-btn-big'>START ASSESSMENT</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        ) :
          <Container>
            <Row>
              <Col xs={12} sm={12} md={12} lg={12} xl={12} className={'mx-auto'}>
                <div className={'mx-auto text-center page-title'}>
                  <div class='videos_headings'>
                  </div>
                  <p>
                    <Interweave content={page ? page.content : 'No Data Available'} />
                  </p>
                </div>
              </Col>
            </Row>
          </Container>
        }



        {/* </section> */}
      </CommonPageData>
      <Footer />
    </>
  );
};
const mapStateToProps = state => {
  return {
    page: state.auth.page
  }
}
export default connect(mapStateToProps, { getPageBySlug })(Page)
